import { render, staticRenderFns } from "./CarAutoForm.vue?vue&type=template&id=3bc0ba18&"
import script from "./CarAutoForm.vue?vue&type=script&lang=js&"
export * from "./CarAutoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports